import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteImagensAreaComum(tenantId: string, id: string) {
  return useMutation(
    `/v1/tenants/${tenantId}/area-comum/:id/imagem/:arquivoId`,
    (arquivoId) =>
      http.delete(
        `/v1/tenants/${tenantId}/area-comum/${id}/imagem/${arquivoId}`
      ),
    { retry: false }
  );
}

export default useDeleteImagensAreaComum;
